import React, { useState } from 'react';
import { getStripe } from '../utils/stripe';

const MONTHLY_PRICE_ID = process.env.REACT_APP_MONTHLY_PRICE_ID;

function PreviewSubscriptionBanner() {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubscribe = async (event) => {
    event.preventDefault();
    if (isLoading) return;

    setError('');
    setIsLoading(true);

    try {
      const payload = { source: 'preview_banner' };
      if (MONTHLY_PRICE_ID) payload.price_id = MONTHLY_PRICE_ID;

      const response = await fetch('/api/payment/create-upgrade-session', {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      const data = await response.json();

      if (!response.ok || !data.sessionId) {
        throw new Error(data.error || 'Could not open checkout. Please try again.');
      }

      const stripe = await getStripe();
      const { error: stripeError } = await stripe.redirectToCheckout({
        sessionId: data.sessionId,
      });
      if (stripeError) throw stripeError;
    } catch (checkoutError) {
      console.error('Preview subscription checkout error:', checkoutError);
      setError(checkoutError.message || 'Could not open checkout. Please try again.');
      setIsLoading(false);
    }
  };

  return (
    <div className="preview-banner" role="status">
      <p>
        You're viewing in preview mode.{' '}
        <a
          href="/register"
          className="preview-subscribe-link"
          onClick={handleSubscribe}
          aria-disabled={isLoading}
        >
          {isLoading ? 'Opening checkout…' : 'Subscribe'}
        </a>{' '}
        to see all cards and features!
      </p>
      {error && <span className="preview-checkout-error" role="alert">{error}</span>}
    </div>
  );
}

export default PreviewSubscriptionBanner;
